import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-skills-certificates',
  templateUrl: './skills-certificates.component.html',
  styleUrls: ['./skills-certificates.component.css']
})
export class SkillsCertificatesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2501, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_skillscertificates_grid')
                .setLoadDataFunction({
                    method: 2505,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'skillscertificates_new',
                    text: 'skillscertificates_new',
                    tooltip: 'skillscertificates_new',
                    translateTooltip: true,
                    func: async () => {
                        const response = (await this.datatask.Post(678, { counter_id: 'skillscertificate_keyno' }))[0];

                        this.stateService?.go('skillscertificate', {
                            labour_no: this.setting?.labour_no,
                            skillscertificate_keyno: response?.nextnumber
                        });
                    },
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true,
                    disabled: () => {
                        if (this.setting?.labour_no !== '0') {
                            return false;
                        } else {
                            return 'hidden';
                        }
                    }
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    page_heading: string;
    labour_no: string;
}
